module.exports = __webpack_public_path__ + "img/many-1.a6f53571.jpg";